module.exports = __webpack_public_path__ + "img/logo.1ede3428.png";